package com.example.mystybag.login.views.views

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.login.logic.MerchantResetPasswordViewModel
import com.example.mystybag.login.views.MerchantResetPasswordForm
import com.example.mystybag.login.views.components.MerchantRegistrationWebBoundedColumn

@Composable
fun MerchantResetPasswordWebView(viewModel: MerchantResetPasswordViewModel) {
    val keyboardController = LocalSoftwareKeyboardController.current
    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) { _ ->
        MerchantRegistrationWebBoundedColumn(Modifier.fillMaxSize()) {
            MerchantResetPasswordForm(
                viewModel = viewModel,
                keyboardController = keyboardController,
                useScrollAndFixedButtonSpacing = true
            )
        }
    }
}
